import { render, staticRenderFns } from "./NextPage.vue?vue&type=template&id=2eecbed2&scoped=true&"
import script from "./NextPage.vue?vue&type=script&lang=js&"
export * from "./NextPage.vue?vue&type=script&lang=js&"
import style0 from "./NextPage.vue?vue&type=style&index=0&id=2eecbed2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eecbed2",
  null
  
)

export default component.exports